enum SimulationType {
    Wef = 'wef',
    PensionCertificate = 'pensionCertificate',
    PensionCalculator = 'pensionCalculator',
    Purchase = 'purchase',
    SavingPlan = 'savingPlan',
}

export default SimulationType;
